import { EMPTY_DISPLAY_VALUE } from '../../constants/index.tsx';

/** Preserves valid zero values and normalizes blank API text to the shared placeholder. */
export const displayApiContent = (value?: number | string | null) => {
  if (typeof value === 'string' && value.trim() === '') {
    return EMPTY_DISPLAY_VALUE;
  }
  return value ?? EMPTY_DISPLAY_VALUE;
};
